export function getBboxBorderColor(className: string): string {
  switch ((className || '').toLowerCase()) {
    case 'swimmer':
      return '#00ff00';
    case 'drowning':
      return '#ff0000';
    case 'lifeguard':
      return '#00b0ff';
    case 'person':
      return '#ffeb3b';
    default:
      return '#ff5252';
  }
}
